import { createContext } from 'react'

export const TenantContext = createContext({})
